import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1772e8', dark: '#125bb7' },
    secondary: { main: '#f59e0b' },
    success: { main: '#22a447' },
    warning: { main: '#e99418' },
    error: { main: '#dc2626' },
    background: { default: '#edf3f8', paper: '#ffffff' },
    text: { primary: '#17263a', secondary: '#65758a' }
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: 'Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    button: { textTransform: 'none', fontWeight: 850 }
  },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 7, boxShadow: 'none' } } },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 9 } } },
    MuiCard: { styleOverrides: { root: { borderRadius: 9 } } }
  }
});

export default theme;
